module.exports = __webpack_public_path__ + "static/media/check.351ff0e1.svg";